import { render, staticRenderFns } from "./ParentCarer.vue?vue&type=template&id=53d22e26&"
import script from "./ParentCarer.vue?vue&type=script&lang=js&"
export * from "./ParentCarer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports